import { useEffect, useState } from "react";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed right-4 md:right-6 bottom-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-lg hover:bg-primary-600 transition-colors"
    >
      <i className="ri-arrow-up-line" />
    </button>
  );
};

export default BackToTop;